/**
 * Универсальный обработчик для форм добавления в корзину с кнопкой .cart-btn2
 * Предотвращает перезагрузку страницы и делает AJAX-запрос
 */
(function() {
  function initCartBtnHandlers() {
    // Находим все формы с кнопкой .cart-btn2
    const forms = document.querySelectorAll('.w-commerce-commerceaddtocartform');
    
    forms.forEach(form => {
      const submitButton = form.querySelector('.cart-btn2');
      
      // Пропускаем формы без кнопки .cart-btn2 или уже обработанные
      if (!submitButton || form.dataset.cartBtnHandlerInitialized === 'true') {
        return;
      }
      
      // Помечаем форму как обработанную
      form.dataset.cartBtnHandlerInitialized = 'true';
      
      // Перехватываем отправку формы (capture), чтобы избежать двойных обработчиков в других секциях
      form.addEventListener('submit', async function(e) {
        // Защита от двойного сабмита (например, несколько обработчиков в теме)
        if (form.dataset.cartBtnHandlerSubmitting === 'true') {
          e.preventDefault();
          e.stopImmediatePropagation();
          e.stopPropagation();
          return false;
        }
        form.dataset.cartBtnHandlerSubmitting = 'true';

        e.preventDefault();
        // Важно: блокируем другие submit-handlers (иначе будет двойное добавление = quantity 2)
        e.stopImmediatePropagation();
        e.stopPropagation();
        
        const errorElement = form.parentElement?.querySelector('.w-commerce-commerceaddtocarterror') || 
                            form.closest('.add-to-cart-4')?.querySelector('.w-commerce-commerceaddtocarterror');
        
        // Показываем состояние загрузки
        const originalValue = submitButton.value;
        submitButton.disabled = true;
        submitButton.value = submitButton.dataset.loadingText || '+';
        submitButton.setAttribute('aria-busy', 'true');
        
        try {
          const formData = new FormData(form);
          
          // Добавляем товар в корзину через AJAX
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            body: formData
          });
          
          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.description || 'Failed to add to cart');
          }
          
          const addResult = await response.json();
          
          // Получаем обновленные данные корзины
          const cartResponse = await fetch('/cart.js');
          const cartData = await cartResponse.json();
          
          // Обновляем счетчик корзины
          const cartCountElements = document.querySelectorAll('.w-commerce-commercecartopenlinkcount');
          cartCountElements.forEach(el => {
            el.textContent = cartData.item_count || 0;
          });
          
          // Обновляем счетчик в других местах
          const bottomStickyCartCount = document.querySelector('.bottom-sticky-menu .w-commerce-commercecartopenlinkcount');
          if (bottomStickyCartCount) {
            bottomStickyCartCount.textContent = cartData.item_count || 0;
          }
          
          const floatingCartCount = document.querySelector('.floating-cart-button .w-commerce-commercecartopenlinkcount');
          if (floatingCartCount) {
            floatingCartCount.textContent = cartData.item_count || 0;
          }
          
          // Диспатчим событие обновления корзины
          const cartUpdateEvent = new CustomEvent('cart:update', {
            bubbles: true,
            cancelable: true,
            detail: {
              resource: cartData,
              sourceId: form.id || 'cart-btn-handler',
              data: {
                source: 'cart-btn-handler',
                itemCount: Number(formData.get('quantity')) || 1,
                variantId: formData.get('id'),
                productId: form.closest('[data-product-id]')?.dataset.productId,
                didError: false
              }
            }
          });
          document.dispatchEvent(cartUpdateEvent);
          
          // Обновляем содержимое попапа корзины
          const webflowCart = document.querySelector('.w-commerce-commercecartcontainer');
          if (webflowCart) {
            // Обновляем содержимое корзины через AJAX
            fetch('/cart.js')
              .then(response => response.json())
              .then(cart => {
                // Обновляем список товаров в корзине
                updateCartPopupContent(cart);
              })
              .catch(err => {
                console.error('Error updating cart popup:', err);
              });
          }
          
          // Открываем корзину
          const cartDrawer = document.querySelector('cart-drawer-component');
          
          if (cartDrawer) {
            try {
              if (typeof cartDrawer.open === 'function') {
                cartDrawer.open();
              } else if (typeof cartDrawer.showDialog === 'function') {
                cartDrawer.showDialog();
              }
            } catch (error) {
              console.error('Error opening cart drawer:', error);
            }
          } else if (webflowCart) {
            webflowCart.classList.add('show');
            document.body.style.overflow = 'hidden';
          }
          
          // Скрываем ошибку, если она была показана
          if (errorElement) {
            errorElement.style.display = 'none';
          }
          
        } catch (error) {
          console.error('Error adding to cart:', error);
          
          // Показываем ошибку
          if (errorElement) {
            const errorText = errorElement.querySelector('[data-w-add-to-cart-general-error]') || 
                             errorElement.querySelector('div');
            if (errorText) {
              errorText.textContent = error.message || 'Something went wrong when adding this item to the cart.';
            }
            errorElement.style.display = 'block';
            errorElement.setAttribute('aria-live', 'assertive');
            
            // Скрываем ошибку через 5 секунд
            setTimeout(() => {
              if (errorElement) {
                errorElement.style.display = 'none';
              }
            }, 5000);
          }
        } finally {
          // Снимаем блокировку сабмита
          form.dataset.cartBtnHandlerSubmitting = 'false';
          // Восстанавливаем состояние кнопки
          submitButton.disabled = false;
          submitButton.value = originalValue;
          submitButton.setAttribute('aria-busy', 'false');
        }
        
        return false;
      }, true);
    });
  }
  
  // Инициализация при загрузке
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartBtnHandlers);
  } else {
    initCartBtnHandlers();
  }
  
  // Также инициализируем при динамическом добавлении контента (например, в каруселях)
  // Используем MutationObserver для отслеживания новых форм
  const observer = new MutationObserver(function(mutations) {
    let shouldReinit = false;
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            if (node.matches && node.matches('.w-commerce-commerceaddtocartform')) {
              shouldReinit = true;
            } else if (node.querySelector && node.querySelector('.w-commerce-commerceaddtocartform')) {
              shouldReinit = true;
            }
          }
        });
      }
    });
    if (shouldReinit) {
      initCartBtnHandlers();
    }
  });
  
  // Начинаем наблюдение за изменениями в DOM
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  // Функция для форматирования денег
  function formatMoney(cents, currency = 'EUR') {
    const amount = cents / 100;
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, window.Shopify.money_format || '{{amount}}');
    }
    const currencySymbol = currency === 'EUR' ? '€' : currency === 'USD' ? '$' : currency;
    return currencySymbol + amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  
  // Функция для обновления содержимого попапа корзины
  function updateCartPopupContent(cart) {
    const cartList = document.querySelector('#webflow-cart-items');
    if (!cartList) return;
    
    if (cart.item_count === 0) {
      cartList.innerHTML = '<div class="w-commerce-commercecartemptystate" style="padding: 40px; text-align: center;"><div aria-label="This cart is empty" aria-live="polite">No items found.</div></div>';
      const footer = document.querySelector('.w-commerce-commercecartfooter');
      if (footer) footer.style.display = 'none';
      return;
    }
    
    // Формируем HTML для товаров
    let itemsHTML = '';
    cart.items.forEach((item, index) => {
      const line = index + 1;
      // Обрабатываем изображение - может быть строкой или объектом
      let imageUrl = '';
      if (typeof item.image === 'string') {
        imageUrl = item.image;
      } else if (item.image && item.image.src) {
        imageUrl = item.image.src;
      } else if (item.featured_image && item.featured_image.url) {
        imageUrl = item.featured_image.url;
      }
      
      const productTitle = item.product_title || item.title || '';
      const variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      const linePrice = item.final_line_price || item.line_price || 0;
      const quantity = item.quantity || 1;
      
      // Форматируем цену
      const formattedPrice = formatMoney(linePrice, cart.currency || 'EUR');
      
      itemsHTML += `
        <div class="w-commerce-commercecartitem" style="display: flex; padding: 20px; border-bottom: 1px solid #e5e5e5; gap: 15px;">
          <img src="${imageUrl}" alt="${productTitle}" class="w-commerce-commercecartitemimage" style="width: 80px; height: 80px; object-fit: cover; border-radius: 8px;">
          <div class="w-commerce-commercecartiteminfo" style="flex: 1;">
            <div class="w-commerce-commercecartproductname" style="font-weight: 600; margin-bottom: 8px;">${productTitle}</div>
            ${variantTitle ? `<div style="font-size: 14px; color: #666; margin-bottom: 8px;">${variantTitle}</div>` : ''}
            <div class="cart-item-line-price" data-line-price="${linePrice}" style="font-weight: 600; margin-bottom: 8px;">${formattedPrice}</div>
            <div style="display: flex; align-items: center; gap: 10px;">
              <input type="number" name="updates[]" value="${quantity}" min="0" class="w-commerce-commercecartquantity cart-quantity-2" style="width: 60px; padding: 5px; border: 1px solid #ddd; border-radius: 4px;" data-line="${line}">
              <a href="/cart/change?line=${line}&quantity=0" class="remove-button-2 w-inline-block" style="padding: 5px; background-color: transparent; border-radius: 4px; text-decoration: none; color: #333; font-size: 18px; width: 24px; height: 24px; display: flex; align-items: center; justify-content: center; cursor: pointer;" aria-label="Remove item">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      `;
    });
    
    cartList.innerHTML = itemsHTML;
    
    // Обновляем общую сумму - используем тот же надежный поиск
    const formattedTotal = formatMoney(cart.total_price, cart.currency || 'EUR');
    let cartTotalElement = document.querySelector('.w-commerce-commercecartordervalue') || 
                          document.querySelector('.text-block-20216');
    
    if (cartTotalElement) {
      cartTotalElement.textContent = formattedTotal;
    } else {
      // Ищем в футере
      const footer = document.querySelector('.w-commerce-commercecartfooter');
      if (footer) {
        const lineItem = footer.querySelector('.w-commerce-commercecartlineitem');
        if (lineItem) {
          const priceDiv = lineItem.querySelector('div:last-child');
          if (priceDiv) {
            priceDiv.textContent = formattedTotal;
          }
        }
      }
    }
    
    // Показываем футер если он был скрыт
    const footer = document.querySelector('.w-commerce-commercecartfooter');
    if (footer) footer.style.display = 'block';
    
    // Переинициализируем обработчики для новых элементов
    setTimeout(() => {
      // Инициализируем обработчики количества
      if (typeof initQuantityHandlers === 'function') {
        initQuantityHandlers();
      }
      // Инициализируем кнопки удаления
      if (typeof initRemoveButtons === 'function') {
        initRemoveButtons();
      }
      // Диспатчим событие для переинициализации
      document.dispatchEvent(new CustomEvent('cart:popup-updated'));
    }, 100);
  }
})();

